import React from 'react'
import './index.scss'

//api
import { api } from '../../../../functions/api'

//material-ui
import CircularProgress from '@material-ui/core/CircularProgress'

//custom components
import Search from '../../../../components/basic/search'
import CustomTable from '../../../../components/complex/customTable'
import CustomSnackbar from '../../../../components/global/snackbar'

//other libraries
import { inject, observer } from 'mobx-react'
import queryString from 'query-string'
import { toJS } from 'mobx'
import OrderDetail from './detail'

const TIMEOUT = 3000

@inject('translate')
@inject('internal')
@observer
export default class ClientOrders extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            openSnackbar: false,
            message: ''
        }
    }

    componentDidMount() {
        this.loadClientOrders()
        this.props.internal.setRoute(
            this.props.routerData.history,
            this.props.routerData.location.pathname
        )
        let idOrder = this.props.routerData.match.params.id
        if (idOrder) {
            let actionEditData = {
                edit: true,
                id: idOrder
            }
            this.props.internal.setActionEdit(actionEditData)
        }
    }

    timeout = null
    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    turnOffSnackBar = () => {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
            this.setState({ message: '', openSnackbar: false })
        }, TIMEOUT)
    }

    loadClientOrders = async (
        size = 10,
        page = 0,
        searchterm = ' ',
        by = 'created_at',
        dir = 'desc'
    ) => {
        //this.setState({loading: true})
        const URLqueryString = this.props.routerData.history.location.search
        let queries = queryString.parse(URLqueryString)

        if (queries) {
            if (queries.page_number) {
                page = queries.page_number
            }

            if (queries.page_size) {
                size = queries.page_size
            }

            if (queries.by) {
                by = queries.by
            }

            if (queries.dir) {
                dir = queries.dir
            }

            if (queries.searchterm) {
                searchterm = queries.searchterm
            }
        }

        let idClient = toJS(this.props.routerData.match.params.idClient)

        let load_data = await api({
            method: 'get',
            url: 'clients/' + idClient + '/orders',
            authorization: this.props.internal.user.access_token,
            params: {
                searchterm: searchterm,
                page: {
                    number: page,
                    size: size
                },
                order: [
                    {
                        by: by,
                        dir: dir
                    }
                ]
            }
        })

        if (load_data.success === true) {
            if (load_data.data) {
                for (let i = 0; i < load_data.data.data.length; i++) {
                    if (load_data.data.data[i].branch) {
                        let branchAdress = load_data.data.data[i].branch.address
                        load_data.data.data[i].branch_address = branchAdress

                        // let role_name = load_data.data.data[i].role.name
                        // load_data.data.data[i].role_name = role_name
                    }
                }
                this.props.internal.setDataForTable(load_data.data)
            }
        }

        this.setState({ loading: false })
    }

    handleChangeRowsPerPage = size => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl('page_size', size)
    }

    handleChangePage = page => {
        this.setState({
            loading: true
        })

        this.addQueryToUrl('page_number', page + 1)
    }

    handleSearch = searchTerm => {
        if (searchTerm.length > 2) {
            this.addQueryToUrl('searchterm', searchTerm)
        } else {
            this.addQueryToUrl('searchterm', '')
        }
    }

    handleSort = (dir, orderBy) => {
        this.setState({
            loading: true
        })
        this.addQueryToUrl('dir', dir)
        this.addQueryToUrl('by', orderBy)
    }

    addQueryToUrl = (param, value) => {
        const URLqueryString = this.props.routerData.history.location.search
        let queries = queryString.parse(URLqueryString)
        queries[param] = value

        let new_path = this.props.routerData.location.pathname

        new_path += '?'
        for (let key in queries) {
            if (key) {
                new_path += key + '=' + queries[key] + '&'
            }
        }
        new_path = new_path.slice(0, -1)

        this.props.internal.pushRoute(new_path)
        this.loadClientOrders()
    }

    handleCloseDialog = () => {
        let actionEditData = {
            edit: false,
            id: null
        }
        this.props.internal.setActionEdit(actionEditData)
        let idClient = this.props.routerData.match.params.idClient
        let tabName = this.props.routerData.match.params.tabName
        this.props.internal.pushRoute(`/clients/${idClient}/${tabName}`)
    }

    showSnackbar = (message, open, resetUrl = false) => {
        this.setState({ message: message, openSnackbar: open })
        this.turnOffSnackBar()
        this.loadClientOrders()
        if (resetUrl) {
            this.handleCloseDialog()
        }
    }

    dropDownMenuItems = [
        {
            title: this.props.translate.i18n.GLOBAL.BUTTONS.DETAIL,
            action: 'detail_order' //detail objednavky
        }
    ]

    tableHeader = [
        { title: 'name', numeric: false },
        { title: 'branch', numeric: false, min_width: '150px' },
        { title: 'date', numeric: false },
        { title: 'status', numeric: false },
        { title: 'price', numeric: true }
    ]
    tableBody = ['order_id', 'branch_address', 'created_at', 'status', 'total']

    render() {
        return (
            <div>
                {this.state.loading ? (
                    <CircularProgress className={'circular-progress'} />
                ) : (
                    <div className={'client-orders'}>
                        <div className={'flex '}>
                            <Search
                                placeholder={
                                    this.props.translate.i18n.MODULES.CLIENTS.SEARCH_ORDERS
                                }
                                classes={'client-search w-100'}
                                onChange={this.handleSearch}
                            />
                        </div>

                        <CustomSnackbar
                            message={this.state.message}
                            open={this.state.openSnackbar}
                        />
                        {this.props.internal.actionEdit.edit ? (
                            <OrderDetail
                                open={this.props.internal.actionEdit.edit}
                                onClose={this.handleCloseDialog}
                                routerData={this.props.routerData}
                                showSnackbar={this.showSnackbar}
                                idOrder={this.props.internal.actionEdit.id}
                            />
                        ) : null}
                        <CustomTable
                            dropDownMenuItems={this.dropDownMenuItems}
                            module={'/clients'}
                            handleChangeRowsPerPage={this.handleChangeRowsPerPage}
                            handleChangePage={this.handleChangePage}
                            handleSort={this.handleSort}
                            header={this.tableHeader}
                            body={this.tableBody}
                        />
                    </div>
                )}
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/screens/clients/detail/orders/index.js